import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getFirstCuisine } from "../../../../utilities/helper";
export default function BasicInfo(props) {
  const restaurant = useSelector((state) => state.restaurant);
  const {
    restaurant_name,
    owner_name,
    cuisine_type,
    phone,
    locality,
    country,
    email,
    state,
    postal_code,
    city,
    status,
    category,
    about,
    reviews,
    meal_type,
    documents,
    sharecode
  } = restaurant;
  const [firstCuisine, setFirstCuisine] = useState('');
  useEffect(() => {
    const ls = getFirstCuisine(cuisine_type);
    setFirstCuisine(ls);
  }, [cuisine_type])


  return (
    <fieldset>
      <div className="row m-b-lg m-t-lg p-3">
        <div className="col-6">
          <div className="row align-items-center">
            <div className="profile-image">
              <img
                src={documents && documents[0].restaurant_image}
                alt="profile"
              />
              <div
                className="status-circle"
                style={
                  status === "Active"
                    ? { backgroundColor: "green" }
                    : { backgroundColor: "red" }
                }
              />
            </div>
            <div className="profile-info">
              <h3 className="no-margins">{restaurant_name}</h3>
              <h4>{owner_name}</h4>
              <address>
                <strong>{locality}</strong>
                <br />
                {city}, {state}, {country} {postal_code}
                <br />
                <abbr title="Email">E: </abbr>
                {email}
                <br />
                <abbr title="Phone">M: </abbr>
                {phone}
              </address>
            </div>
          </div>
        </div>
        <div className="col-3">
          <table className="table small m-b-xs">
            <tbody>
              <tr>
                <td>
                  <strong>{reviews && reviews.length}</strong> Stars
                </td>
                <td>
                  <strong>{reviews && reviews.length}</strong> Reviews
                </td>
              </tr>
              <tr>
                <td>CUISINE TYPE</td>
                <td>{firstCuisine}</td>
              </tr>
              <tr>
                <td>COMMISSION</td>
                <td>
                  8{"%"}
                </td>
              </tr>
              <tr>
                <td>Meal Type</td>
                <td>{meal_type}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-3">
          <div className="row">
            <h5 className="text-capitalize" >sharing link</h5>
            <small className="no-margins">
              <i className="fa fa-android" style={{ color: "#a4c639" }} /> https://play.google.com/store/apps/details?id=com.feasti.feasti_user&sharecode={sharecode}
            </small>
            <small className="no-margins">
              <i className="fa fa-apple" style={{ color: "#000" }} /> https://apps.apple.com/us/app/feasti-homecooked-food/id1645705596?sharecode={sharecode}
            </small>
          </div>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-lg-4">
          <div className="form-group">
            <h4 className="m-t-none m-b">MEAL TIME</h4>
            <p>{category}</p>
          </div>
        </div>
        <div className="col-lg-8">
          <div className="form-group">
            <h4 className="m-t-none m-b">About</h4>
            <p>{about}</p>
          </div>
        </div>
      </div>
    </fieldset>
  );
}
